import SpriteSymbol from "../../../../../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "linkedin-solid",
  "use": "linkedin-solid-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"linkedin-solid\"><path fill=\"var(--bolt-theme-icon, currentColor)\" d=\"M5 26.8h4.8V12.3H4.8zm5-19a2.5 2.5 0 00-2.6-2.4 2.5 2.5 0 100 5A2.5 2.5 0 0010 7.9zm12.3 19H27v-8.3c0-4.4-2.4-6.5-5.6-6.5a4.7 4.7 0 00-4.3 2.4v-2h-4.8v14.4h4.8v-8a3.5 3.5 0 01.2-1.3 2.7 2.7 0 012.4-1.7c1.8 0 2.5 1.3 2.5 3.3v7.7zM32 6v20a6 6 0 01-6 6H6a6 6 0 01-6-6V6a6 6 0 016-6h20a6 6 0 016 6z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol